import { useForm } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { useAddPaymentRequestsMutation } from 'modules/banking/hooks/useAddPaymentRequests'
import type { SelectAllFilters } from 'modules/banking/components/PayPaymentRequestsInBulkModal'

export interface AddPaymentRequestsFormValues {
  paymentId: string
  paymentRequestIds: string[]
}

export const useAddPaymentRequestsForm = ({
  onSuccess,
  paymentRequestIds,
  selectAll,
  excludedPaymentRequestIds,
  filters,
}: {
  onSuccess: () => void
  paymentRequestIds: string[]
  selectAll?: boolean
  excludedPaymentRequestIds?: string[]
  filters?: SelectAllFilters
}) => {
  const { submitAddPaymentRequests, loading } = useAddPaymentRequestsMutation()

  const form = useForm<AddPaymentRequestsFormValues>({
    defaultValues: {
      paymentId: '-1',
      paymentRequestIds: paymentRequestIds,
    },
    validateOnChange: false,
    validate: (values) => {
      const errors: Record<string, string> = {}

      if (values.paymentId === '-1') {
        errors.paymentId = i18n.t('banking.bulk_payment.forms.validation_mandatory')
      }

      return errors
    },
    onSubmit: async (values) => {
      return await submitAddPaymentRequests({
        paymentRequestIds: values.paymentRequestIds,
        paymentId: values.paymentId,
        onSuccess: onSuccess,
        selectAll,
        excludedPaymentRequestIds,
        filters,
      })
    },
  })

  return {
    form,
    loading,
  }
}
